<div class="clug-list-card">
  <div class="card-loader" *ngIf="loading">
    <mat-spinner diameter="28"></mat-spinner>
  </div>

  <div class="card-header">
    <span class="card-header-count">{{totalCount}} Assignment(s)</span>
  </div>

  <div class="table-responsive">
    <table matSort (matSortChange)="sortData($event)" class="table">
      <thead>
        <tr>
          <th mat-sort-header="job" scope="col">Job</th>
          <th mat-sort-header="client" scope="col">Client</th>
          <th mat-sort-header="start_date" scope="col">Start Date</th>
          <th mat-sort-header="end_date" scope="col">End Date</th>
          <th mat-sort-header="created_at" scope="col">Created At</th>
          <th mat-sort-header="status" scope="col">Status</th>
          <th *ngIf="user?.role_uuid === ROLES?.CANDIDATE" mat-sort-header="action" scope="col" class="actions-col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr class="assignmentsRow dataColumn" *ngFor="let jobAssignment of jobAssignments">
          <td>
            <div class="cell-with-icon">
              <span class="cell-icon"><i class="bi bi-briefcase"></i></span>
              <span class="cell-text">{{jobAssignment.job}}</span>
            </div>
          </td>
          <td>{{jobAssignment.client}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.start_date)}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.end_date)}}</td>
          <td>{{dataSharedService.tranformDate(jobAssignment.created_at)}}</td>
          <td>
            <span class="pill pending" *ngIf="jobAssignment.status === 2">Pending</span>
            <span class="pill submitted" *ngIf="jobAssignment.status === 3">Details Submitted</span>
            <span class="pill rejected text-cursor" *ngIf="jobAssignment.status === 4" (click)="viewRejectReason(jobAssignment.reason)">Rejected</span>
            <span class="pill rejected text-cursor" *ngIf="jobAssignment.status === 5" (click)="viewRejectReason(jobAssignment.reason)">Permanent Rejected</span>
            <span class="pill submitted" *ngIf="jobAssignment.status === 6">Details Resubmitted</span>
          </td>
          <td *ngIf="user?.role_uuid === ROLES?.CANDIDATE" class="td-actions">
            <button *ngIf="jobAssignment.status === 2"
                    class="btn btn-primary btn-sm bt-square ms-1 px-3 py-1 fs-7"
                    (click)="viewOnBoardingForm(jobAssignment)"
                    matTooltip="Submit Onboarding Details" [matTooltipPosition]="'left'">
              Submit Onboarding Details
            </button>
            <button *ngIf="jobAssignment.status === 3 || jobAssignment.status === 6"
                    class="btn btn-success btn-sm bt-square ms-1 px-3 py-1 fs-7"
                    matTooltip="Once approved by the agency, you can view the job in the Active tab and create a timesheet"
                    style="margin-bottom: 0px;">
              Pending Agency Approval
            </button>
            <button *ngIf="jobAssignment.status === 4"
                    class="btn btn-success btn-sm bt-square ms-1 px-3 py-1 fs-7"
                    (click)="viewOnBoardingForm(jobAssignment)"
                    matTooltip="Agency has rejected your onboarding details, you can update your onboarding form details and submit again"
                    [matTooltipPosition]="'left'">
              Edit Onboarding Details
            </button>
            <div *ngIf="(jobAssignment.status === 3 || jobAssignment.status === 4 || jobAssignment.status === 6) && jobAssignment.is_contract_submitted === false && jobAssignment.is_contract_uploaded === true"
                 class="btn btn-neutral btn-sm bt-square ms-1 px-3 py-1 fs-7"
                 (click)="viewOnBoardingForm(jobAssignment, true)"
                 matTooltip="Submit Contract" [matTooltipPosition]="'left'">
              <i class="bi bi-c-square"></i>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="card-pagination" *ngIf="totalCount">
    <span class="pagination-summary">
      Showing {{ pageStart }}–{{ pageEnd }} of {{ totalCount }} requests
    </span>
    <app-api-paginator [totalCount]="totalCount" (onStepChange)="onStepChange($event)"></app-api-paginator>
  </div>
</div>
